module.exports = __webpack_public_path__ + "img/words.bb441f0e.svg";